















import { defineComponent, computed } from "@vue/composition-api";
import { app, alarm, sensor } from "@/store";
import { ref } from "@vue/composition-api";

export default defineComponent({
    props: {
    },
    setup(props) {
        const muteText = computed((): string => {
            return alarm.syncSiren ? "Silencing" : "Silence siren";
        });

        const sirenSyncronising = computed(() => {
            return alarm.syncSiren;
        });

        const muteAlarm = () => {
            alarm.stopSiren();
        };

        return {
            muteText,
            sirenSyncronising,
            muteAlarm
        };
    }
});
